import { useState, useCallback } from 'react';
import TableHeader from '../components/TableHeader/TableHeader';
import TableView from '../components/TableView/TableView';
import './table_view.css';

const TableViewPage = () => {
  const [exportDisabled, setExportDisabled] = useState(true);
  const [exportHandler, setExportHandler] = useState<(() => void) | null>(null);
  const [getUpdatesHandler, setGetUpdatesHandler] = useState<(() => void) | null>(null);

  const handleSelectionChange = useCallback((hasSelection: boolean) => {
    setExportDisabled(!hasSelection);
  }, []);

  const registerExportHandler = useCallback((handler: () => void) => {
    setExportHandler(() => handler);
  }, []);

  const registerGetUpdatesHandler = useCallback((handler: () => void) => {
    setGetUpdatesHandler(() => handler);
  }, []);

  return (
    <div className="table-header-container">
      <TableHeader
        exportDisabled={exportDisabled}
        onExport={exportHandler || undefined}
        onGetUpdates={getUpdatesHandler || undefined}
      />
      <TableView
        onSelectionChange={handleSelectionChange}
        onRegisterExport={registerExportHandler}
        onRegisterGetUpdates={registerGetUpdatesHandler}
      />
    </div>
  );
 };
 
 export default TableViewPage;